/**
 * Resize Handle
 *
 * 4px handle at top or bottom of an event block for resizing duration.
 */

import clsx from 'clsx';

interface ResizeHandleProps {
  edge: 'top' | 'bottom';
  onPointerDown: (e: React.PointerEvent) => void;
}

export function ResizeHandle({ edge, onPointerDown }: ResizeHandleProps) {
  return (
    <div
      className={clsx(
        'absolute left-0 right-0 h-1 cursor-ns-resize z-10 group/resize',
        'hover:bg-accent-violet/30 transition-colors',
        edge === 'top' ? 'top-0 rounded-t' : 'bottom-0 rounded-b'
      )}
      onPointerDown={onPointerDown}
    >
      <div
        className={clsx(
          'absolute left-1/2 -translate-x-1/2 w-8 h-[3px] rounded-full bg-text-quaternary/0 group-hover/resize:bg-text-quaternary/50 transition-colors',
          edge === 'top' ? 'top-0.5' : 'bottom-0.5'
        )}
      />
    </div>
  );
}
